
import React from 'react'

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer-content">
				<p>© {new Date().getFullYear()} Yiyi He. All Rights Reserved.</p>
			</div>
		</footer>
	)
}

export default Footer
